import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";

export interface FooterLink {
  label: string;
  to: string;
  icon?: LucideIcon;
  external?: boolean;
  emoji?: string;
}

interface FooterLinksProps {
  title: string;
  links: FooterLink[];
}

export const FooterLinks = ({ title, links }: FooterLinksProps) => {
  return (
    <div>
      <h4 className="font-semibold mb-4">{title}</h4>
      <ul className="space-y-2 text-sm">
        {links.map((link, index) => (
          <li key={index}>
            {link.external ? (
              <a
                href={link.to}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
              >
                {link.icon && <link.icon className="w-4 h-4" aria-hidden="true" />}
                {link.emoji && <span aria-hidden="true">{link.emoji}</span>}
                {link.label}
              </a>
            ) : (
              <Link
                to={link.to}
                className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
              >
                {link.icon && <link.icon className="w-4 h-4" aria-hidden="true" />}
                {link.emoji && <span aria-hidden="true">{link.emoji}</span>}
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
